import RTMMaskedInput from 'react-text-mask';
import React from 'react';
import PropTypes from 'prop-types';

function BaseMaskedInput({
  id,
  className,
  onAnimationStart,
  onFocus,
  onBlur,
  disabled,
  required,
  inputRef,
  onChange,
  placeholder,
  mask,
  value,
}) {
  const placeholderDistinctCharsMap = mask.reduce((acc, curr) => {
    if (typeof curr === 'string') {
      acc[curr] = true;
    }

    return acc;
  }, {});

  const re = new RegExp(`[_${Object.keys(placeholderDistinctCharsMap).join('')}]`, 'g');

  return (
    <RTMMaskedInput
      id={id}
      className={className}
      onBlur={onBlur}
      onFocus={onFocus}
      onAnimationStart={onAnimationStart}
      disabled={disabled}
      required={required}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      onChange={(evt) => {
        return onChange(evt.target.value.replaceAll(re, ''));
      }}
      mask={mask}
      placeholder={placeholder}
      value={value}
    />
  );
}

BaseMaskedInput.defaultProps = {
  id: undefined,
  onBlur: undefined,
  onFocus: undefined,
  className: undefined,
  disabled: false,
  required: false,
  onAnimationStart: undefined,
};

BaseMaskedInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onAnimationStart: PropTypes.func,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  mask: PropTypes.array.isRequired,
};

export default BaseMaskedInput;
